/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Header2 from "ui/kit/typography/Header2";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import PieceSettingsDebouncedItem from "ui/feature/piece-settings/PieceSettingsDebouncedItem";
import {
    PieceSettingsTempoItem_piece$data
} from "ui/feature/piece-settings/__generated__/PieceSettingsTempoItem_piece.graphql";
import UpdatePieceFileChangeTempo from "mutation/UpdatePieceFileChangeTempo";

interface Props {
    piece: PieceSettingsTempoItem_piece$data
}

const PieceSettingsTempoItem: React.FC<Props> = ({piece}) => {

    const initialText = React.useMemo(() => {
        if (piece.file?.tempo) {
            return piece.file.tempo.toString()
        } else {
            return ""
        }
    }, [piece]);

    const performSave = React.useCallback(async (val: string) => {
        const newVal = parseFloat(val);
        if (isNaN(newVal)) {
            // TODO (dito) send an error
            return;
        }
        await UpdatePieceFileChangeTempo(piece.id, newVal);
    }, [piece.id]);

    return (
        <div>
            <Header2>Tempo in Beats per Minute</Header2>
            <PieceSettingsDebouncedItem
                initialText={initialText}
                performSave={performSave}
            />
        </div>
    )
}

export default createFragmentContainer(PieceSettingsTempoItem, {
    piece: graphql`
        fragment PieceSettingsTempoItem_piece on MusicPiece {
            id
            file {
                tempo
            }
        }
    `
});
